import React from 'react';
import { cn } from '../../utils/cn';

export function Label({ children, htmlFor, className, ...props }) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn('text-sm font-medium text-slate-700 mb-1 block', className)}
      {...props}
    >
      {children}
    </label>
  );
}

